import axios from 'axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarMatriculados = () => {
  const [detalles, setDetalles] = useState([]);
  const [cargando, setCargando] = useState(true);
  const navigate = useNavigate();

  // Este `id` viene de la ruta de esta pantalla.
  // Asumimos que es el ID de la MATRÍCULA (o del grupo/ficha que uses para listar).
  const { id: matriculaId } = useParams();

  // Ver detalle del aprendiz
  const verDetalle = useCallback(
    (idAprendiz) => {
      if (idAprendiz) {
        navigate(`/aprendiz/${idAprendiz}`);
      }
    },
    [navigate]
  );

  // Ir a registrar etapa productiva con DOS params: aprendizId + matriculaId
  const irEtapaProductiva = useCallback(
    (idAprendiz) => {
      if (!idAprendiz) {
        return Swal.fire({
          icon: 'warning',
          title: 'ID no encontrado',
          text: 'No se encontró el ID del aprendiz.',
        });
      }
      if (!matriculaId) {
        return Swal.fire({
          icon: 'warning',
          title: 'Matrícula no encontrada',
          text: 'No se encontró el ID de la matrícula en la ruta actual.',
        });
      }
      navigate(`/etapaproductiva/registro/${idAprendiz}/${matriculaId}`);
    },
    [navigate, matriculaId]
  );

  // Eliminar detalle de matrícula
  const deleteDetalleMatricula = useCallback(
    async (idDetalle) => {
      try {
        const { data } = await axios.delete(`/api/detallematricula/delete/${idDetalle}`);

        if (data.ok) {
          await Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          getData(); // recarga
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo eliminar el detalle.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error al eliminar detalle',
          text: error.response?.data?.message || error.message,
        });
      }
    },
    [] // lo dejamos estable; invocamos getData() por referencia más abajo
  );

  // Obtener datos
  const getData = useCallback(async () => {
    setCargando(true);
    try {
      const { data } = await axios.get(`/api/detallematricula/listbyid/${matriculaId}`);
      console.log('Respuesta de la API:', data);

      if (data?.ok && Array.isArray(data.detalles)) {
        setDetalles(
          data.detalles.map((detalle) => ({
            ...detalle,
            nombreCompleto: detalle.nombreAprendiz || '',
            funciones: (
              <div className="d-flex gap-2">
                {/* Ver detalle */}
                <button
                  className="btn btn-primary btn-sm"
                  style={{ width: 30, height: 30, padding: 0 }}
                  onClick={() => verDetalle(detalle.aprendizObjectId?._id)}
                  title="Más Información del aprendiz"
                >
                  <i className="fa-solid fa-circle-info fa-lg" style={{ color: '#ffffff' }}></i>
                </button>

                {/* Registrar etapa productiva: manda aprendizId + matriculaId (de esta ruta) */}
                <button
                  className="btn btn-success btn-sm"
                  style={{ width: 30, height: 30, padding: 0 }}
                  onClick={() => irEtapaProductiva(detalle.aprendizObjectId?._id)}
                  title="Registrar Etapa Productiva"
                >
                  <i className="fa-solid fa-building fa-lg"></i>
                </button>

                {/* Eliminar */}
                <button
                  className="btn btn-danger btn-sm"
                  style={{ width: 30, height: 30, padding: 0 }}
                  onClick={() => deleteDetalleMatricula(detalle._id)}
                  title="Eliminar detalle de matrícula"
                >
                  <i className="fa-solid fa-trash fa-lg"></i>
                </button>
              </div>
            ),
          }))
        );
      } else {
        throw new Error('No se encontraron detalles para esta matrícula.');
      }
    } catch (error) {
      console.error('Error al cargar los detalles:', error);
      alert(
        'Error al cargar los detalles: ' +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setCargando(false);
    }
  }, [matriculaId, verDetalle, irEtapaProductiva]);

  useEffect(() => {
    if (matriculaId) getData();
  }, [matriculaId, getData]);

  // Columnas de la tabla
  const columns = useMemo(
    () => [
      { Header: 'Ficha', accessor: 'fichaGrupo' },
      { Header: 'Documento', accessor: 'documentoAprendiz' },
      { Header: 'Nombre Completo', accessor: 'nombreCompleto' },
      { Header: 'Estado', accessor: 'estadoMatricula' },
      { Header: 'Tipo', accessor: 'tipoMatricula' },
      { accessor: 'funciones' },
    ],
    []
  );

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1 className="mb-3 px-3">Lista de Matriculados</h1>

      {cargando ? (
        <p className="px-3">Cargando detalles de matrícula...</p>
      ) : detalles.length > 0 ? (
        <DataTable columns={columns} data={detalles} />
      ) : (
        <p className="px-3">No se encontraron registros.</p>
      )}
    </div>
  );
};

export default ListarMatriculados;
